export default __webpack_public_path__ + "static/media/banner-0.cea59b53.png";